export default __webpack_public_path__ + "static/logo-0410fb200e1476a7fc68bcde8340b134.svg";